import type { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'

import { FeatureFlagKeys } from '@hapana/shared/constants/feature-flag.constants'
import { useSettledFeatureFlag } from '_hooks/use-awaited-feature-flag.hooks'

import { ROUTES } from '../../../app.constants'

interface BrandRetailSalesSettingsRouteGuardProps {
  children: ReactElement
}

const BrandRetailSalesSettingsRouteGuard = ({
  children,
}: BrandRetailSalesSettingsRouteGuardProps) => {
  const isBrandAddOnsEnabled = useSettledFeatureFlag(FeatureFlagKeys.BrandControlsAddOnsEnabled)
  const isAddOnsManagementEnabled = useSettledFeatureFlag(FeatureFlagKeys.AddOnsManagementEnabled)
  if (isBrandAddOnsEnabled === false || isAddOnsManagementEnabled === false) {
    return <Navigate to={`/c/${ROUTES.controlCenter.path}`} replace />
  }
  if (isBrandAddOnsEnabled === null || isAddOnsManagementEnabled === null) {
    return null
  }
  return children
}

export default BrandRetailSalesSettingsRouteGuard
